<template>
  <VConfirmation v-model="actionModel" class="row" :heading="actionHeadline" v-bind="$attrs" v-on="$listeners">
    <template #prompt>
      <span v-html="promptText"></span>
    </template>
  </VConfirmation>
</template>

<script>
import VConfirmation from '@/components/Confirmation';

export default {
  name: 'StockProductButtonConfirmationGeneric',

  components: {
    VConfirmation,
  },

  inheritAttrs: false,

  props: {
    action: {
      type: Object,
      required: false,
      default: null,
    },

    texts: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      textMappings: {
        prompt: {
          reservationTermination: this.texts.orderReservationDeletionQuestion,
          reactivation: this.texts.orderReactivationQuestion,
        },
      },
    };
  },

  computed: {
    actionModel: {
      get() {
        return this.action;
      },
      set(v) {
        this.$emit('update:action', v);
      },
    },

    actionName() {
      return this.actionModel?.name;
    },

    actionHeadline() {
      return this.actionModel?.headline;
    },

    promptText() {
      return this.textMappings.prompt[this.actionName] || this.$t(`substore.prompt_${this.actionName}`);
    },
  },
};
</script>
